import React from "react";

type InsuranceRenderProps = {
  currency: string;
  amount: number;
  quantity?: number;
};

export function InsuranceRender({ amount, currency, quantity = 1 }: InsuranceRenderProps) {
  const unit = amount / quantity;
  return (
    <>
      {quantity} x {unit.toFixed(2)} = {amount.toFixed(2)} {currency}
    </>
  );
}
